import { defineStore } from "pinia";
import useApi from "~/composables/useApi";

export const useDownloaderStore = defineStore("downloaderStore", {
  state: () => ({
    downloaderPolicyId: "" as string,
    downloaderPolicyNumber: "" as string,
    downloaderTableRecordId: "" as string,
    downloaderProposerId: "" as string,
    downloaderDocumentId: "" as string,
    downloaderDocumentName: "" as string,
    downloaderFinalLinkGenerated: false,
    downloaderModalShow: false,
    downloaderFinalLink: "" as string | undefined,
  }),

  actions: {
    setDownloader(
      downloaderPolicyId: string,
      downloaderPolicyNumber: string,
      downloaderTableRecordId: string,
      downloaderProposerId: string,
      downloaderDocumentId: string,
      downloaderDocumentName: string
    ) {
      this.downloaderPolicyId = downloaderPolicyId;
      this.downloaderPolicyNumber = downloaderPolicyNumber;
      this.downloaderTableRecordId = downloaderTableRecordId;
      this.downloaderProposerId = downloaderProposerId;
      this.downloaderDocumentId = downloaderDocumentId;
      this.downloaderDocumentName = downloaderDocumentName;
      this.downloaderModalShow = true;
      this.downloaderFinalLinkGenerated = false;
    },

    async refreshDocuments() {
      const { getDocuments } = useApi();

      if (
        !this.downloaderTableRecordId ||
        !this.downloaderPolicyId ||
        !this.downloaderProposerId
      ) {
        console.warn(
          "Downloader store missing identifiers — cannot refresh documents."
        );
        return { success: false, data: [] };
      }

      try {
        const { success, data } = await getDocuments(
          this.downloaderTableRecordId,
          this.downloaderPolicyId,
          this.downloaderProposerId
        );

        if (!success) {
          console.error("Failed to refresh documents from API.");
          return { success: false, data: [] };
        }

        return { success: true, data };
      } catch (err) {
        console.error("Error refreshing documents:", err);
        return { success: false, data: [] };
      }
    },
  },
});
